/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef} from 'react'
import ApexCharts, {ApexOptions} from 'apexcharts'
import {getCSSVariableValue} from '../../../assets/ts/_utils'

type Props = {
  className: string
  chartColor: string
  chartHeight: string
  chartSeries?: any[]
}

const MixedWidget11: React.FC<Props> = ({className, chartColor, chartHeight, chartSeries}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  useEffect(() => {
    if (!chartRef.current) {
      return
    }

    const chart = new ApexCharts(chartRef.current, chartOptions(chartColor, chartHeight, chartSeries?.length ? chartSeries : []))
    if (chart) {
      chart.render()
    }

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartRef, chartSeries])

  return (
    <div className={`card ${className}`}>
      {/* begin::Body */}
      <div className='card-body p-0 d-flex justify-content-between flex-column overflow-hidden'>
        {/* begin::Hidden */}
        <div className='d-flex flex-stack flex-wrap item-top flex-grow-1 px-9 pt-6'>
          <div className='me-2'>
            <span className='fw-bolder text-gray-800 d-block fs-3'>Costo Minutas</span>

            {/* <span className='text-gray-400 fw-bold'>8 Jul  - 26 Jul  2022</span> */}
          </div>

          {/* <div className={`fw-bolder fs-3 text-${chartColor}`}>$150,300</div> */}
        </div>
        {/* end::Hidden */}

        {/* begin::Chart */}
        <div ref={chartRef} className='mixed-widget-10-chart'></div>
        {/* end::Chart */}
      </div>
    </div>
  )
}

const chartOptions = (chartColor: string, chartHeight: string, series: any[]): ApexOptions => {
  const labelColor = getCSSVariableValue('--bs-gray-500')
  const borderColor = getCSSVariableValue('--bs-gray-200')
  const color1 = "#FFC000"
  const color2 = "#A5A5A5"
  const color3 = "#ED7D31"
  const color4 = "#4472C4"
  const color5 = "#5CC444"
  const color6 = "#9C44C4"
  const color7 = "#CE31ED"
  const color8 = "#ED3131"

  const initSeries: any[] = [
    {
      name: 'Junio',
      data: [370, 70, 2133, 2570, 1713, 1713],
    },
    {
      name: 'Mayo',
      data: [238, 90, 2340, 2764, 1843, 1843],
    },
    {
      name: 'Abril',
      data: [250, 102, 2510, 2910, 1940, 1940],
    },
    {
      name: 'Marzo',
      data: [300, 100, 2600, 3000, 2000, 2000],
    },
  ]

  return {
    series: series,
    chart: {
      fontFamily: 'inherit',
      type: 'bar',
      height: chartHeight,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        columnWidth: '50%',
        borderRadius: 2,
      },
    },
    legend: {
      show: true,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: ['Bajo costo sitio', 'Bajo costo AMD', 'En costo sitio', 'En costo AMD', 'Sobre costo sitio', 'Sobre costo AMD'],
      axisBorder: {
        show: true,
      },
      axisTicks: {
        show: true,
      },
      labels: {
        style: {
          colors: labelColor,
          fontSize: '14px',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: labelColor,
          fontSize: '14px',
        },
      },
    },
    fill: {
      type: 'solid',
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
    tooltip: {
      style: {
        fontSize: '14px',
      },
      y: {
        formatter: function (val) {
          // return '$' + val + ' revenue'
          return val+''
        },
      },
    },
    colors: [color1, color2 , color3, color4, color5, color6, color7, color8],
    grid: {
      padding: {
        top: 0,
      },
      borderColor: borderColor,
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
  }
}

export {MixedWidget11}
